import React from 'react';
import PlainCRUD from 'components/PlainCRUD';
import {
  getUMAs, postUMAs, patchUMAs, deleteAUMAs,
} from 'api/configuracion';
import toCurrency from 'utils/toCurrency';

// eslint-disable-next-line react/prop-types
const UMA = ({ permission }) => (
  <PlainCRUD
    title="UMA"
    permission={permission}
    get={getUMAs}
    post={postUMAs}
    patch={patchUMAs}
    delete={deleteAUMAs}
    fields={[
      {
        name: 'anio',
        label: 'Año',
        colWidth: 100,
      },
      {
        name: 'valor_diario',
        label: 'Valor Diario',
        colWidth: 100,
        render: (val) => toCurrency(val),
      },
      {
        name: 'valor_mensual',
        label: 'Valor Mensual',
        colWidth: 100,
        render: (val) => toCurrency(val),
      },
      {
        name: 'valor_anual',
        label: 'Valor Anual',
        colWidth: 100,
        render: (val) => toCurrency(val),
      },
    ]}
    // readOnly
  />
);

export default UMA;
